import { type FC, type ReactNode } from "react";

import { CaseStepTabs } from "@styled/case_steps";
import { PageHeaderAction, PageHeaderTabs } from "@styled/page";

import { type CaseStepLine, type IntakeType } from "./case_status_lines";

// Unified project-detail section view. The case's steps, in the header where
// its tabs were, double as the consult selector — picking a step sets BOTH the
// work area and the assistant scope, so there's a single source of truth and
// nothing to sync. Supporting documents isn't a step (it has no state): it's a
// quiet link in the header row, beside the ✦ Assistant button (`assistant`,
// only in the sections that have one). The selected section renders below.
export const Intake: FC<{
  steps: CaseStepLine[];
  selected: IntakeType;
  onSelect(key: IntakeType): void;
  supportingLink: ReactNode;
  assistant?: ReactNode;
  children: ReactNode;
}> = ({ steps, selected, onSelect, supportingLink, assistant, children }) => (
  <div>
    <PageHeaderTabs>
      <CaseStepTabs
        steps={steps}
        selected={selected === "supporting" ? null : selected}
        onSelect={onSelect}
      />
    </PageHeaderTabs>
    <PageHeaderAction>
      {supportingLink}
      {assistant}
    </PageHeaderAction>
    <div className="space-y-3">{children}</div>
  </div>
);
